<p *ngIf="!readonly">
  <button app-add-button
    [disabled]="readonly"
    [label]="'communications.mass-comm-message-edit.mass-comm-send.attachments.add-attachment-button' | translate | titlecase"
    (click)="showFileSelector()"
  >
  </button>
</p>

<ul class="list-group" *ngIf="message?.Attachments?.length">
  <li class="list-group-item clear-fix" *ngFor="let attachment of message.Attachments">
    <div class="pull-right" *ngIf="!readonly">
      <button pButton type="button" class="atlas-btn btn-sm atlas-btn-danger" (click)="removeAttachment(attachment)" icon="pi pi-trash"></button>
    </div>
    {{ attachment.FileName }}
  </li>
</ul>

<p [hidden]="message?.Attachments?.length">
  {{ 'communications.mass-comm-message-edit.mass-comm-send.attachments.no-attachments-message' | translate }}
</p>

<p-dialog
  #fileLookupModal
  modal="true"
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h3>{{ 'communications.mass-comm-message-edit.mass-comm-send.attachments.attach-file' | translate | titlecase }}</h3>
  </ng-template>

  <p>
    {{ 'communications.mass-comm-message-edit.mass-comm-send.attachments.content-type-label' | translate | titlecase }}
    <select class="form-control-like" [(ngModel)]="uploadWebContentTypeId" (change)="handleWebContenTypeChange()">
      <option value=""></option>
      <option *ngFor="let webContentType of webContentTypes" [value]="webContentType.ContentTypeID">
        {{ webContentType.ContentType }}
      </option>
    </select>
  </p>

  <p-fileUpload
    #fileUploader
    name="files1[]"
    [url]="uploadUrl"
    (onUpload)="onUploadComplete($event)"
    (onError)="onUploadError($event)"
    [showUploadButton]="false"
    [showCancelButton]="false"
    multiple="true"
  >
  </p-fileUpload>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger" [hidden]="!uploadFileError">{{ uploadFileError }}</div>
    <wl-busy [show]="uploading"></wl-busy>

    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      (click)="handleUploadClick()"
      [disabled]="uploading"
      icon="pi pi-upload"
      [label]="'common.upload' | translate | titlecase"
    ></button>

    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-secondary"
      (click)="handleFileUploadCancelClick()"
      [disabled]="uploading"
      icon="pi pi-ban"
      [label]="'common.cancel' | translate | titlecase"
    ></button>
  </ng-template>
</p-dialog>
